export function trimmedBlockRangeLeft(state, range) {
  const {from} = trimmedBlockRange(state, range);
  const to = range.to;

  return {
    from,
    to,
    text: state.sliceDoc(from, to)
  };
}

export function trimmedBlockRange(state, {from, to}) {
  const text = state.sliceDoc(from, to);
  return {
    from: from + (text.length - trimStartToNewLine(text).length),
    to: to - (text.length - trimEndFromNewLine(text).length),
    text: trimToNewLines(text)
  };
}

export function trimToNewLines(text) {
  return trimStartToNewLine(trimEndFromNewLine(text));
}

function trimStartToNewLine(text) {
  const match = text.match(/^(\s*\n) *\S/);
  if (match) {
    const [_, untilLastNewLine] = match;
    return text.substr(untilLastNewLine.length);
  }
  return text;
}

function trimEndFromNewLine(text) {
  const match = text.match(/\S *(\n\s*)$/);
  if (match) {
    const [_, lastNewLineAndMore] = match;
    return text.substr(0, text.length - lastNewLineAndMore.length);
  }
  return text;
}

export function blank(string) {
  return string.trim() === '';
}
